<template>
    <div class="wrapper">
        <div class=" padding-sm bg-white margin-bottom-sm">
            <div class="flex align-start justify-between margin-bottom-sm">
                <h3 class="page-title line-height">会员基本信息</h3>
                <el-button class="blue-btn" round type="primary" @click="$router.go(-1)"
                >返回
                </el-button
                >
            </div>
            <el-form ref="ruleForm" :model="infoForm" class="ruleForm" label-width="auto" label-position="top">
                <el-row :gutter="20">
                    <el-col v-if="examine_msg" :span="24">
                        <div class="margin-bottom" style="color: #ff0000">
                            拒绝原因：{{ examine_msg }}
                        </div>
                    </el-col>
                    <el-col v-for="(item,index) in infoForm.list"
                            :key="index" :span="(item.type === 2 || item.type ===6|| item.type ===7) ? 24 : 12">
                        <el-form-item v-if="item.type === 1" :label="item.title" :prop="'list.' + index + '.answer'"
                                      :rules="item.rules">
                            <el-input v-model="item.answer" :placeholder="item.placeholder || '请输入' + item.title"></el-input>
                        </el-form-item>
                        <el-form-item v-if="item.type === 2" :label="item.title" :prop="'list.' + index + '.answer'"
                                      :rules="item.rules">
                            <el-input v-model="item.answer" :placeholder="'请输入' + item.title"
                                      type="textarea"></el-input>
                        </el-form-item>
                        <el-form-item v-if="item.type === 3  && !item.hide" :label="item.title" :prop="'list.' + index + '.answer'"
                                      :rules="item.rules">
                            <el-select v-model="item.answer" :placeholder="'请选择' + item.title" class="w-all"
                                       clearable :disabled="item.disabled">
                                <el-option v-for="option in item.options" :key="option.value"
                                           :label="option.label"
                                           :value="option.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item v-if="item.type === 4" :label="item.title" :prop="'list.' + index + '.answer'"
                                      :rules="item.rules">
                            <el-select v-model="item.answer" :placeholder="'请选择' + item.title" class="w-all"
                                       clearable multiple>
                                <el-option v-for="option in item.options" :key="option.value"
                                           :label="option.label"
                                           :value="option.value"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item v-if="item.type === 5" :label="item.title" :prop="'list.' + index + '.answer'"
                                      :rules="item.rules">
                            <el-cascader
                                v-model="item.answer"
                                :options="options"
                                expand-trigger="hover"
                                filterable
                                placeholder="请选择单位所在地"
                                style="width: 100%;"
                            >
                            </el-cascader>
                        </el-form-item>
                        <el-form-item v-if="item.type === 6" :label="item.title" :prop="'list.' + index + '.answer'"
                                      :rules="item.rules">
                            <infoUpFile :file="item.answer" :index="index" :limit="item.limit" :type="item.type"
                                        @saveFile="saveFile"/>
                        </el-form-item>
                        <el-form-item v-if="item.type === 7" :label="item.title" :prop="'list.' + index + '.answer'"
                                      :rules="item.rules">
                            <infoUpFile :file="item.answer" :index="index" :limit="item.limit" :type="item.type"
                                        @saveFile="saveFile"/>
                        </el-form-item>

                        <el-form-item v-if="item.type === 8" :label="item.title"  :prop="'list.' + index + '.answer'" :rules="item.rules">
                            <el-date-picker
                                v-model="item.answer"
                                placeholder="请选择日期"
                                style="width: 100%"
                                value-format="yyyy-MM-dd"
                                type="date">
                            </el-date-picker>
                        </el-form-item>

                    </el-col>
                    <el-col :span="12" v-if="false">
                        <el-form-item label="会员证书编号">
                            <el-input v-model="zhengshu_code" placeholder="请输入会员证书编号"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                    <el-form-item label="到期时间" required>
                        <el-date-picker
                            v-model="infoEndTime"
                            placeholder="请选择会员到期日期"
                            style="width: 100%"
                            value-format="yyyy-MM-dd"
                            type="date">
                        </el-date-picker>
                    </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label-width="0">
                            <div class="flex justify-center"  v-if="user.isBranch && examine_stage === 1">
                                <el-button class="blue-btn big-btn" @click="saveForm('ruleForm')">修改保存</el-button>
                                <el-button class="blue-btn big-btn" @click="saveForm2('ruleForm',1)">通过</el-button>
                                <el-button v-if="is_check === 0" class="line-btn big-btn"
                                           @click="saveForm2('ruleForm',2)">拒绝
                                </el-button>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
    </div>
</template>

<script>
import infoUpFile from "@/components/InfoUpFile";
import {getApplyUserData,getPersonalInformation, getInformation, getRankList, memberApplyEdit, memberCheck} from "@/api/branch";
import {regionData} from "element-china-area-data";
import {zhDate,patternChange} from "@/utils/utils";
import {showOrgFenHui} from "../../../../api/branch";


export default {
    name: "info",
    data() {
        return {
            memberId: '',
            zhengshu_code: '',
            infoEndTime: '',
            infoForm: {
                list: [],
            },
            options: regionData,
            levelList: [],
            is_check: 0,
            examine_stage: 0,
            examine_msg: '',
        }
    },
    created() {
        this.$emit('setIndex', [3, 1], '会员设置')
        this.memberId = Number(this.$route.params.id)
        this.getMemberDetail()
    },
    components: {
        infoUpFile
    },
    computed:{
        user() {
            return this.$store.state.user
        }
    },
    methods: {
        //  审核判断
        saveForm2(formName, state) {
            this.$refs[formName].clearValidate()
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (state === 1) {
                        this.passInfo()
                    } else {
                        this.refuseInfo()
                    }
                } else {
                    this.$message.error('信息填写有误，请确认！')
                }
            });

        },
        //  通过
        async passInfo() {
            if (!this.infoEndTime) return this.$message.error('请选择到期时间')
            let _state = await memberCheck(this.$route.params.id, 1, '',this.infoEndTime,this.zhengshu_code)
            if (_state.status === 200) {
                this.$message.success('操作成功')
                this.$router.go(-1)
            }
        },
        //  拒绝
        refuseInfo() {
            this.$prompt('请输入拒绝原因', '拒绝原因', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
            }).then(({value}) => {
                if (!value) return this.$message.error('请输入拒绝原因')
                this.sureRefuse(value)
            })
        },
        async sureRefuse(str) {
            let _state = await memberCheck(this.$route.params.id, 2, str,this.infoEndTime,this.zhengshu_code)
            if (_state.status === 200) {
                this.$message.success('操作成功')
                this.$router.go(-1)
            }
        },
        //  修改信息
        saveForm(formName) {
            this.$refs[formName].clearValidate()
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.sureSave()
                } else {
                    this.$message.error('信息填写有误，请确认！')
                }
            });

        },
        async sureSave() {
            let _state = await memberApplyEdit(JSON.stringify(this.infoForm.list), this.memberId,this.infoEndTime,this.zhengshu_code)
            if (_state.status === 200) {
                this.$message.success('修改成功')
                this.$router.go(-1)
            }

        },
        //  同步附件信息
        saveFile(val) {
            const _index = val[0]
            this.infoForm.list[_index].answer = val[1]
            this.$set(this.infoForm.list, _index, this.infoForm.list[_index])

        },
        //  获取会员等级列表
        async getLevel(user_type) {
            let _data = await getRankList(user_type)
            _data.data.map(item => {
                item.value = item.id
                item.label = item.name
            })
            this.levelList = _data.data
            // _data = await getfenhuiList(this.user.parent_id,this.user.fhid)
            // _data.data.map(item => {
            //     item.value = item.id
            //     item.label = item.name
            // })
            // let _organizs = _data.data
            _data = await showOrgFenHui(this.user.fhid)
            this.userInfo = _data.data
            this.infoForm.list = patternChange(this.infoForm.list,this.levelList,this.userInfo.name,[],this.userInfo.id)
        },
        //  获取表单
        async getInformation(user_type,user_more_json) {
            let _data = user_type === 1 ?  await getInformation() : await getPersonalInformation()
            if (_data.status === 200) this.infoForm.list = JSON.parse(_data.data.user_more_json)
            await this.getLevel(user_type)
            this.showDetail(JSON.parse(user_more_json))
        },
        //  获取会员信息
        async getMemberDetail() {
            let _data = await getApplyUserData(this.memberId)
            this.is_check = _data.data.is_check
            this.examine_msg = _data.data.examine_msg
            this.examine_stage = _data.data.examine_stage
            this.infoEndTime = _data.data.end_time ? zhDate(Number(_data.data.end_time)*1000) : ''
            this.getInformation(_data.data.user_type,_data.data.user_more_json)
        },
        showDetail(obj) {
            obj.map(item => {
                this.infoForm.list.map(items => {
                    if (item.title === items.title  ||  (item.field || '')  === items.field || items.field === item.title) {
                        items.answer = item.answer
                    }
                })
            })
        }
    },
    filters: {},
    watch: {},
}
</script>

<style lang="scss" scoped>
.left-title {
    width: 100px;
}
</style>
